import React, { useState, useEffect, useCallback } from 'react';

const SECTIONS = [
  { id: 'section-hero',    label: 'Objekt' },
  { id: 'section-kpis',   label: 'KPIs' },
  { id: 'section-score',  label: 'Score' },
  { id: 'section-kosten', label: 'Kosten' },
  { id: 'section-markt',  label: 'Markt' },
  { id: 'section-signals',label: 'Signale' },
  { id: 'section-summary',label: 'Fazit' },
];

export default function SectionDots() {
  const [active, setActive] = useState(SECTIONS[0].id);

  const handleIntersect = useCallback((entries) => {
    // Find the topmost visible section
    const visible = entries
      .filter((e) => e.isIntersecting)
      .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
    if (visible.length > 0) {
      setActive(visible[0].target.id);
    }
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(handleIntersect, {
      root: null,
      rootMargin: '-20% 0px -60% 0px',
      threshold: 0,
    });

    SECTIONS.forEach(({ id }) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, [handleIntersect]);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div
      className="hidden lg:flex flex-col items-end gap-2"
      style={{
        position: 'fixed',
        right: 24,
        top: '50%',
        transform: 'translateY(-50%)',
        zIndex: 40,
      }}
    >
      {SECTIONS.map(({ id, label }) => {
        const isActive = active === id;
        return (
          <button
            key={id}
            onClick={() => scrollTo(id)}
            title={label}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: '2px 0',
            }}
          >
            {/* Label — only visible on hover via CSS group, here always shown when active */}
            <span style={{
              fontSize: 11,
              fontWeight: 500,
              color: isActive ? '#1DB3B3' : '#ACACB8',
              transition: 'color 150ms ease',
              opacity: isActive ? 1 : 0,
              transform: isActive ? 'translateX(0)' : 'translateX(4px)',
              transition: 'opacity 150ms ease, transform 150ms ease, color 150ms ease',
              pointerEvents: 'none',
              userSelect: 'none',
            }}>
              {label}
            </span>

            {/* Dot */}
            <div style={{
              width: isActive ? 10 : 6,
              height: isActive ? 10 : 6,
              borderRadius: '50%',
              background: isActive ? '#1DB3B3' : '#C8C8D0',
              transition: 'all 200ms ease',
              flexShrink: 0,
            }} />
          </button>
        );
      })}
    </div>
  );
}
